import { appendUTM } from 'services'

export const appendSlackAltUTM = (link: string) =>
    appendUTM(link, { utm_campaign: 'slack_alternative' })
